import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { NgToggleComponent, NgToggleAccessorDirective } from '@nth-cloud/ng-toggle';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DeviceService } from '@app/services/device.service';
import { SettingService } from '@app/services/setting.service';
import { DeviceBaseComponent } from '@app/shared/device-base.component';
import { Device } from '@app/store/device.model';
import { getCurrentValue } from '@app/util';

@Component({
  selector: 'app-brake-control',
  styles: ['.btn.disabled, .btn:disabled { opacity: .75 }'],
  templateUrl: './brake-control.component.html',
  imports: [FormsModule, NgbPopover, NgToggleComponent, NgToggleAccessorDirective, AsyncPipe],
})
export class BrakeControlComponent extends DeviceBaseComponent {
  private deviceService = inject(DeviceService);
  private settingService = inject(SettingService);

  model: any = {
    offColor: 'primary',
    offText: 'BRAKE ENGAGED',
    onColor: 'info',
    onText: 'BRAKE RELEASED',
    size: '',
  };

  showBrakeWarning$ = this.settingService.showBrakeWarning$;
  brakeEngaged$: Observable<boolean>;
  showBrakeWarningAndBrakeEngaged$: Observable<boolean>;
  toggleDisabled$: Observable<boolean>;
  isBrakeControlledBySmm$: Observable<boolean>;

  onDeviceChange(device: Device) {
    this.brakeEngaged$ = this.deviceService.selectDeviceBrakeEngaged(device);
    this.isBrakeControlledBySmm$ = this.deviceService.selectDeviceIsBrakeControlledBySmm(device);

    this.showBrakeWarningAndBrakeEngaged$ = combineLatest([this.showBrakeWarning$, this.brakeEngaged$]).pipe(
      map(([showBrakeWarning, brakeEngaged]) => showBrakeWarning && brakeEngaged),
    );

    this.toggleDisabled$ = combineLatest([this.showBrakeWarningAndBrakeEngaged$, this.isBrakeControlledBySmm$]).pipe(
      map(([showBrakeWarningAndBrakeEngaged, isBrakeControllerBySmm]) => {
        return showBrakeWarningAndBrakeEngaged || isBrakeControllerBySmm;
      }),
    );
  }

  onValueChange(value: any) {
    if (typeof value === 'boolean') {
      const brakeEngaged = getCurrentValue(this.brakeEngaged$);
      if (value === brakeEngaged) {
        // don't send the request to Motion Master if requested value is the same as current
        setTimeout(() => {
          // this is a hack that allows onPopoverClick to execute before brakeOptionsStatus is changed
          if (value) {
            this.deviceService.requestBrakeRelease(this.device);
          } else {
            this.deviceService.requestBrakeEngage(this.device);
          }
        });
      }
    }
  }

  onPopoverClick(p: NgbPopover) {
    const showBrakeWarningAndBrakeEngaged = getCurrentValue(this.showBrakeWarningAndBrakeEngaged$);
    if (showBrakeWarningAndBrakeEngaged) {
      p.open();
    }
  }

  onReleaseClick(p: NgbPopover) {
    this.deviceService.requestBrakeRelease(this.device);
    p.close();
  }

  toggleShowBrakeWarning() {
    this.settingService.toggleShowBrakeWarning();
  }
}
